import React, { PureComponent, Fragment } from 'react';
import classnames from 'classnames';
import { connect } from 'unistore/react';
import Switch from '~/core/scripts/components/Switch';
import actions from '~/scripts/state/actions';
import { is768Query } from '~/core/scripts/mediaquery-helper';
import config from '../config';

const isSmallScreen = !is768Query();

class DataToggle extends PureComponent {
  componentDidMount() {
  }
  onToggleData() {
    this.props.onClick();
  }
  onSelectKreistag() {
    if(this.props.isKommune) {
      this.props.onClick();
    }
  }
  onSelectGemeinde() {
    if(!this.props.isKommune) {
      this.props.onClick();
    }
  }
  render() {
    const itemClasses1 = classnames(
      'datatoggle__text',
      { 'is-active': !this.props.isKommune}
    );
    const itemClasses2 = classnames(
      'datatoggle__text',
      { 'is-active': this.props.isKommune}
    );
    return (
      <div className="datatoggle">
        <div className="datatoggle__box">
          <div className={itemClasses1} onClick={(evt) => this.onSelectKreistag(evt)}>Kreistagswahl</div>
          <Switch checked={this.props.isKommune} onChange={(evt) => this.onToggleData(evt)}/>
          <div className={itemClasses2} onClick={(evt) => this.onSelectGemeinde(evt)}>Gemeinderatswahl</div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({

}), actions)(DataToggle);
